var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "changes-input" }, [
    _c("label", { staticClass: "ci-label mb-0" }, [
      _vm._v("\n        Max changes\n        "),
      _c("br"),
      _vm._v(" "),
      _c("input", {
        staticClass: "ci-input",
        attrs: { type: "text" },
        domProps: { value: _vm.value.changes },
        on: { input: _vm.updateChanges },
      }),
    ]),
    _vm._v(" "),
    _c("label", { staticClass: "ci-label mb-0" }, [
      _vm._v("\n        Extra change time (mins)\n        "),
      _c("br"),
      _vm._v(" "),
      _c("input", {
        staticClass: "ci-input",
        attrs: { type: "text" },
        domProps: { value: _vm.value.time },
        on: { input: _vm.updateTime },
      }),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }